export const ColorPalettes: any = {
  Pulseem: ['#FF4D2A', '#FF0076', '#ccff00', '#FF3343', '#27AE60', '#959595', '#3498DB', '#FFD4E2', '#FFAAC6'],
  BlueberryTwilight: ['#02b2af', '#2e96ff', '#b800d8', '#60009b', '#2731c8', '#03008d', '#52516d', '#275b8f', '#5890c9'],
  MangoFusion: ['rgb(23, 58, 94)', 'rgb(0, 163, 160)', 'rgb(201, 27, 99)', 'rgb(239, 83, 80)', 'rgb(255, 167, 38)', 'rgb(184, 0, 216)', 'rgb(96, 0, 155)', 'rgb(46, 150, 255)', 'rgb(39, 49, 200)', 'rgb(3, 0, 141)'],
  CheerfulFiesta: ['rgb(0, 58, 117)', 'rgb(0, 127, 255)', 'rgb(255, 194, 76)', 'rgb(255, 157, 9)', 'rgb(202, 108, 0)', 'rgb(18, 125, 148)', 'rgb(31, 148, 173)', 'rgb(200, 38, 52)', 'rgb(255, 49, 67)', 'rgb(255, 126, 126)'],
  NormalDay: ['#37AFE1', '#4CC9FE', '#F5F4B3', '#FFFECB', '#C6E7FF', '#D4F6FF', '#FFDDAE'],
  Olive: ['#1A1A19', '#31511E', '#859F3D', '#5b7302', '#395144', '#4E6C50', '#AA8B56', '#F0EBCE']
}

export const ColorPalettesStyles =
  {
    Pulseem: {
      fill: 'black !important'
    },
    BlueberryTwilight: {
      fill: '#fff !important',
    },
    MangoFusion: {
      fill: '#fff !important',
    },
    CheerfulFiesta: {
      fill: '#fff !important',
    },
    NormalDay: {
      fill: 'black !important',
    },
    Olive: {
      fill: '#fff !important',
    }
  } as any;